export default "__VITE_ASSET__DT48qOIJ__"